export const BytesToMB = (bytes: number) => {
  return (bytes / (1024 * 1024)).toFixed(2); // Convert to MB and round to 2 decimal places
};

export const FormatAudioDuration = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};
